import { render, staticRenderFns } from "./MarketDataPage.vue?vue&type=template&id=a07a3c98&scoped=true"
import script from "./MarketDataPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketDataPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MarketDataPage.vue?vue&type=style&index=0&id=a07a3c98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07a3c98",
  null
  
)

export default component.exports